import { useState } from "react";
import { useNavigate } from "react-router-dom";
import HeaderPreRegistration from "../../Components/HeaderPreRegistration";
import { useLocation } from "react-router-dom";

const PreRegistrationRef = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [displayError, setDisplayError] = useState(location.state?.error || "");

  const [dmnRef, setDmnRef] = useState("");

  const handleSubmit = async () => {
    // reset previous error messages
    setDisplayError("");

    if (!dmnRef || dmnRef.length < 7) {
      setDisplayError("Please enter a valid DMN booking reference.");
      return;
    }

    navigate(`/pre-registration/DMN-${dmnRef}`);
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#070d27] text-white">
      <HeaderPreRegistration hideHome={true} />

      {/* page container to give side padding on mobile */}
      <div className="w-full max-w-md mx-auto px-4">
        <h1 className="text-2xl sm:text-3xl mt-6 text-center Kallisto_Bold">
          Enter your DMN booking reference
        </h1>

        <div className="mt-3 mb-2 min-h-[1.5rem] text-center flex items-center justify-center">
          {displayError && (
            <span className="text-red-500 Kallisto_Bold break-words">
              {displayError}
            </span>
          )}
        </div>

        <div className="mt-3 mb-6">
          <div className="flex flex-nowrap items-center gap-2 bg-[#1f2644] rounded-md px-4 py-4 w-full">
            <span className="shrink-0 whitespace-nowrap text-lg text-gray-300 Kallisto_Bold">
              DMN&nbsp;-
            </span>
            <input
              type="text"
              inputMode="numeric"
              pattern="\d*"
              value={dmnRef}
              onChange={(e) => setDmnRef(e.target.value.replace(/\D/g, ""))}
              className="bg-transparent flex-1 min-w-0 text-white text-lg Kallisto_Bold focus:outline-none focus:ring-0"
              placeholder=""
            />
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <button
            onClick={handleSubmit}
            className="bg-[#3F50F6] hover:bg-[#2d3fcc] py-4 px-8 rounded w-full sm:w-[250px] flex items-center justify-center"
          >
            <span className="text-white Kallisto_Bold font-bold whitespace-nowrap">
              Confirm
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PreRegistrationRef;
